import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function calcRestante(janelaExpiraEm) {
  if (!janelaExpiraEm) return null;
  const diff = new Date(janelaExpiraEm).getTime() - Date.now();
  if (diff <= 0) return null;
  return Math.floor(diff / 1000); // segundos restantes
}

function formatarRestante(segundos) {
  if (segundos === null) return null;
  const horas = Math.floor(segundos / 3600);
  const minutos = Math.floor((segundos % 3600) / 60);
  if (horas > 0) return `${horas}h ${minutos}m`;
  return `${minutos}m`;
}

export default function JanelaIndicator({ janelaExpiraEm }) {
  const [restante, setRestante] = useState(() => calcRestante(janelaExpiraEm));

  useEffect(() => {
    setRestante(calcRestante(janelaExpiraEm));

    const intervalo = setInterval(() => {
      setRestante(calcRestante(janelaExpiraEm));
    }, 60_000);

    return () => {
      clearInterval(intervalo);
    };
  }, [janelaExpiraEm]);

  const fechada = !janelaExpiraEm || restante === null;

  if (fechada) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-ink-4 bg-surface-2 border border-white/[0.08] rounded-full px-2.5 py-1">
        <span className="w-1.5 h-1.5 rounded-full bg-surface-4" />
        Janela fechada
      </span>
    );
  }

  const umHoraEmSegundos = 3600;
  const isUrgente = restante <= umHoraEmSegundos;

  return (
    <span
      className={`inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-2.5 py-1 border ${
        isUrgente
          ? "text-amber-300 bg-amber-950 border-amber-800"
          : "text-emerald-300 bg-emerald-950 border-emerald-800"
      }`}
      title={`Janela expira em ${new Date(janelaExpiraEm).toLocaleString("pt-BR")}`}
    >
      <Clock className="w-3 h-3" />
      Janela aberta &middot; {formatarRestante(restante)}
    </span>
  );
}
